module.exports = __webpack_public_path__ + "img/feature_yj.06ea547d.gif";